import styled from 'styled-components';
import { Collapse } from 'antd';

export const WhatsappLink = styled.a`
  > img {
    width: 20px;
    height: 20px;
  }
`;

export var StyledCollapse = styled(Collapse)`
  &.ant-collapse {
    background: transparent;
    border: none;
  }

  & > .ant-collapse-item {
    margin-bottom: 16px;
    border: 1px solid #d9d9d9;
    border-radius: 8px;
    overflow: hidden;

    &:last-child {
      margin-bottom: 0;
    }
  }

  & > .ant-collapse-item > .ant-collapse-header {
    background: #fafafa;
    padding: 12px 16px !important;
    border-bottom: 1px solid #d9d9d9;
  }

  & > .ant-collapse-item > .ant-collapse-content {
    border-top: none;
    background: #fff;
  }

  & > .ant-collapse-item > .ant-collapse-content > .ant-collapse-content-box {
    padding: 24px 16px 16px 16px !important;
    background: #fff;
  }
`;